import React from "react";
import { AlertCircleIcon, SpinnerIcon } from "../../../Icons";
import { DOCUMENT_BTN, DOCUMENT_MODAL } from "../documentTheme";

const DeleteConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  isLoading,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-slate-900/40"
      role="dialog"
      aria-modal="true"
      aria-labelledby="delete-confirm-title"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget && !isLoading) onClose?.();
      }}
    >
      <div className={`${DOCUMENT_MODAL.panel} max-w-md`}>
        <div className={DOCUMENT_MODAL.head}>
          <div className="min-w-0 flex items-start gap-3">
            <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-red-100">
              <AlertCircleIcon
                className="h-5 w-5 text-red-600"
                aria-hidden="true"
              />
            </span>
            <div className="min-w-0">
              <h3 id="delete-confirm-title" className={DOCUMENT_MODAL.title}>
                {title || "Confirm Deletion"}
              </h3>
              <p className="mt-1 text-[13px] text-slate-600 font-normal normal-case tracking-normal">
                {message ||
                  "Are you sure you want to delete this item? This action cannot be undone."}
              </p>
            </div>
          </div>
        </div>

        <div className={DOCUMENT_MODAL.footer}>
          <button
            type="button"
            disabled={isLoading}
            onClick={onClose}
            className={DOCUMENT_BTN.modalCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            disabled={isLoading}
            onClick={onConfirm}
            className="inline-flex items-center justify-center gap-1.5 h-9 px-3 text-sm font-semibold rounded-md bg-red-600 text-white hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? (
              <SpinnerIcon className="animate-spin" size={14} />
            ) : null}
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
